import type { BaseApiResponse } from './types/api.types';

import { post, get } from './axios';

export interface HealthHoldStatus {
  held: boolean;
  heldAt: null | string;
}

export interface HealthHoldArgs {
  organizationId: string;
  clientId: string;
}

export interface ReleaseHealthHoldArgs extends HealthHoldArgs {
  note?: string;
}

const base = ({ clientId, organizationId }: HealthHoldArgs) =>
  `/v2/organizations/${organizationId}/clients/${clientId}/health-hold`;

/** 6.11 — is this client waiting to be let in after a stopping PAR-Q answer? */
export const fetchHealthHold = async (args: HealthHoldArgs) => {
  const response = await get<BaseApiResponse<HealthHoldStatus>>(base(args));
  return response?.data ?? { held: false, heldAt: null };
};

/** "Approve access": the owner or the client's trainer lets them in. */
export const releaseHealthHold = async ({
  note,
  ...args
}: ReleaseHealthHoldArgs) => {
  const response = await post<{ released: number }>(`${base(args)}/release`, {
    note: note?.trim() || undefined,
  });
  return response?.data ?? { released: 0 };
};
